import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const styles = (theme) => ({
  root: {
    position: 'absolute',
    background: theme.palette.common.white,
    width: 600,
    top: 55,
    marginLeft: -5,
    zIndex: 200
  },
  list: {
    maxHeight: 400,
    overflow: 'scroll'
  },
  sublist: {
    paddingLeft: 10,
  }
});

class SearchResults extends Component {

  groupedResults = (results) => {
    let topidx = 0;
    return results.map((r, idx) => {
      const res = (
        <React.Fragment>
          <ListItem>
            <ListItemText primary={r.title} />
          </ListItem>
          <List>
            {r.hits.map((h, subidx) => this.createResult(h, topidx+subidx))}
          </List>
          <Divider />
        </React.Fragment>
      );
      topidx += r.hits.length;
      return res;
    });
  }

  createResult  = (item, idx) => {
    const { selected, onSelect, classes } = this.props;
    const key = `${item.entityType}-${item.id}`;
    return (
      <ListItem
        button
        onClick={onSelect(item)}
        key={key}
        selected={selected === idx}
      >
        <ListItemText
          className={classes.sublist}
          primary={item.title}
          secondary={`id:${item.id}`} />
      </ListItem>
    )
  };

  render() {
    const { classes, results } = this.props;
    return (
      <Paper square align="center" className={classes.root}>
        {!!results && results.length > 0 && (
          <Paper className={classes.list}>
            {!!results && this.groupedResults(results) }
          </Paper>
        )}
      </Paper>
    )
  }
}

SearchResults.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SearchResults);
